const SETTINGS = {
    LOADING_PROPERTIES: {
        loader: 'bars',
        opacity: 0.4,
        color: 'var(--primary-color)',
        width: 128,
        height: 128
    },
    USE_DARK_MODE: 'AppSettingUseDarkMode',
    MENU_MODE: 'AppSettingMenuMode',
    SURFACE_THEME: 'AppSettingSurfaceTheme',
    PRIMARY_THEME: 'AppSettingPrimaryTheme',
    PRESET_THEME: 'AppSettingPresetTheme',
    CURRENT_LOCALE: 'AppSettingCurrentLocale'
};

export default SETTINGS;
